import { kpiData } from "../../data/mock";
import { TrendingUp, TrendingDown, DollarSign, Users, AlertTriangle } from "lucide-react";
import { total, usd, type ExecutiveTransaction } from "../../data/executiveOverview";


const iconMap: Record<string, React.ElementType> = {
  DollarSign,
  TrendingUp,
  Users,
  AlertTriangle,
};

// SVG icons for each KPI
const customSvgMap: Record<string, React.ReactNode> = {
  totalSpend: (
    <svg width="82" height="34" viewBox="0 0 82 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.75 32.75L8.02273 26.2635L15.2955 29.2905L22.5682 19.777L29.8409 21.9392L37.1136 14.5878L44.3864 16.3176L51.6591 11.1284L58.9318 11.9932L66.2045 6.80405L73.4773 8.96622L80.75 0.75V32.75H0.75Z" fill="url(#paint0_linear_335_1318)" />
      <path d="M0.75 32.75L8.02273 26.2635L15.2955 29.2905L22.5682 19.777L29.8409 21.9392L37.1136 14.5878L44.3864 16.3176L51.6591 11.1284L58.9318 11.9932L66.2045 6.80405L73.4773 8.96622L80.75 0.75" stroke="#7C3AED" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <defs>
        <linearGradient id="paint0_linear_335_1318" x1="0.75" y1="0.75" x2="0.75" y2="32.75" gradientUnits="userSpaceOnUse">
          <stop stop-color="#7C3AED" stop-opacity="0.18" />
          <stop offset="1" stop-color="#7C3AED" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  ),
  spendUnderManagement: (
    <svg width="82" height="34" viewBox="0 0 82 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.750244 32.75L8.02297 29.55L15.2957 23.15L22.5684 19.95L29.8412 16.75L37.1139 13.55H44.3866L51.6593 10.35L58.9321 7.15L66.2048 3.95H73.4775L80.7502 0.75V32.75H0.750244Z" fill="url(#paint0_linear_335_1335)" />
      <path d="M0.750244 32.75L8.02297 29.55L15.2957 23.15L22.5684 19.95L29.8412 16.75L37.1139 13.55H44.3866L51.6593 10.35L58.9321 7.15L66.2048 3.95H73.4775L80.7502 0.75" stroke="#7C3AED" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <defs>
        <linearGradient id="paint0_linear_335_1335" x1="0.750244" y1="0.75" x2="0.750244" y2="32.75" gradientUnits="userSpaceOnUse">
          <stop stop-color="#7C3AED" stop-opacity="0.18" />
          <stop offset="1" stop-color="#7C3AED" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  ),
  classifiedSpend: (
    <svg width="82" height="34" viewBox="0 0 82 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.75 32.75L8.02273 27.4167L15.2955 22.0833L22.5682 16.75H29.8409L37.1136 11.4167H44.3864L51.6591 6.08333H58.9318H66.2045L73.4773 0.75H80.75V32.75H0.75Z" fill="url(#paint0_linear_335_1352)" />
      <path d="M0.75 32.75L8.02273 27.4167L15.2955 22.0833L22.5682 16.75H29.8409L37.1136 11.4167H44.3864L51.6591 6.08333H58.9318H66.2045L73.4773 0.75H80.75" stroke="#7C3AED" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <defs>
        <linearGradient id="paint0_linear_335_1352" x1="0.75" y1="0.75" x2="0.75" y2="32.75" gradientUnits="userSpaceOnUse">
          <stop stop-color="#7C3AED" stop-opacity="0.18" />
          <stop offset="1" stop-color="#7C3AED" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  ),
  savingsIdentified: (
    <svg width="82" height="34" viewBox="0 0 82 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.75 32.75L8.02273 27.4167H15.2955L22.5682 22.0833H29.8409L37.1136 16.75H44.3864L51.6591 11.4167H58.9318L66.2045 6.08333L73.4773 0.75H80.75V32.75H0.75Z" fill="url(#paint0_linear_335_1369)" />
      <path d="M0.75 32.75L8.02273 27.4167H15.2955L22.5682 22.0833H29.8409L37.1136 16.75H44.3864L51.6591 11.4167H58.9318L66.2045 6.08333L73.4773 0.75H80.75" stroke="#7C3AED" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <defs>
        <linearGradient id="paint0_linear_335_1369" x1="0.75" y1="0.75" x2="0.75" y2="32.75" gradientUnits="userSpaceOnUse">
          <stop stop-color="#7C3AED" stop-opacity="0.18" />
          <stop offset="1" stop-color="#7C3AED" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  ),
  maverickSpend: (
    <svg width="82" height="34" viewBox="0 0 82 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.750061 32.75V0.75L8.02279 5.59848L15.2955 7.53788L22.5682 10.447L29.841 13.3561L37.1137 15.2955L44.3864 17.2348L51.6592 20.1439L58.9319 23.053L66.2046 25.9621L73.4773 29.8409L80.7501 32.75H0.750061Z" fill="url(#paint0_linear_335_1387)" />
      <path d="M0.750061 0.75L8.02279 5.59848L15.2955 7.53788L22.5682 10.447L29.841 13.3561L37.1137 15.2955L44.3864 17.2348L51.6592 20.1439L58.9319 23.053L66.2046 25.9621L73.4773 29.8409L80.7501 32.75" stroke="#EF4444" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <defs>
        <linearGradient id="paint0_linear_335_1387" x1="0.750061" y1="0.75" x2="0.750061" y2="32.75" gradientUnits="userSpaceOnUse">
          <stop stop-color="#EF4444" stop-opacity="0.18" />
          <stop offset="1" stop-color="#EF4444" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  ),
  supplierCount: (
    <svg width="82" height="34" viewBox="0 0 82 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.750122 32.75V0.75L8.02285 5.20063L15.2956 9.65125L22.5683 11.8766L29.841 14.1019L37.1138 16.3272L44.3865 18.5525L51.6592 20.7778L58.9319 23.0031L66.2047 25.2284L73.4774 29.234L80.7501 32.75H0.750122Z" fill="url(#paint0_linear_335_1404)" />
      <path d="M0.750122 0.75L8.02285 5.20063L15.2956 9.65125L22.5683 11.8766L29.841 14.1019L37.1138 16.3272L44.3865 18.5525L51.6592 20.7778L58.9319 23.0031L66.2047 25.2284L73.4774 29.234L80.7501 32.75" stroke="#F59E0B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <defs>
        <linearGradient id="paint0_linear_335_1404" x1="0.750122" y1="0.75" x2="0.750122" y2="32.75" gradientUnits="userSpaceOnUse">
          <stop stop-color="#F59E0B" stop-opacity="0.18" />
          <stop offset="1" stop-color="#F59E0B" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  ),
  strategicSupplierDependency: (
    <svg width="82" height="34" viewBox="0 0 82 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.75 32.75L8.02273 26.2635L15.2955 29.2905L22.5682 19.777L29.8409 21.9392L37.1136 14.5878L44.3864 16.3176L51.6591 11.1284L58.9318 11.9932L66.2045 6.80405L73.4773 8.96622L80.75 0.75V32.75H0.75Z" fill="url(#paint0_linear_335_1318)" />
      <path d="M0.75 32.75L8.02273 26.2635L15.2955 29.2905L22.5682 19.777L29.8409 21.9392L37.1136 14.5878L44.3864 16.3176L51.6591 11.1284L58.9318 11.9932L66.2045 6.80405L73.4773 8.96622L80.75 0.75" stroke="#7C3AED" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <defs>
        <linearGradient id="paint0_linear_335_1318" x1="0.75" y1="0.75" x2="0.75" y2="32.75" gradientUnits="userSpaceOnUse">
          <stop stop-color="#7C3AED" stop-opacity="0.18" />
          <stop offset="1" stop-color="#7C3AED" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  ),
  aiConfidenceScore: (
    <svg width="82" height="34" viewBox="0 0 82 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.75 32.75L8.02273 26.2635L15.2955 29.2905L22.5682 19.777L29.8409 21.9392L37.1136 14.5878L44.3864 16.3176L51.6591 11.1284L58.9318 11.9932L66.2045 6.80405L73.4773 8.96622L80.75 0.75V32.75H0.75Z" fill="url(#paint0_linear_335_1318)" />
      <path d="M0.75 32.75L8.02273 26.2635L15.2955 29.2905L22.5682 19.777L29.8409 21.9392L37.1136 14.5878L44.3864 16.3176L51.6591 11.1284L58.9318 11.9932L66.2045 6.80405L73.4773 8.96622L80.75 0.75" stroke="#7C3AED" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <defs>
        <linearGradient id="paint0_linear_335_1318" x1="0.75" y1="0.75" x2="0.75" y2="32.75" gradientUnits="userSpaceOnUse">
          <stop stop-color="#7C3AED" stop-opacity="0.18" />
          <stop offset="1" stop-color="#7C3AED" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  ),
};

export function KPIGrid({ rows }: { rows?: ExecutiveTransaction[] }) {
  const spend = rows ? total(rows, "Spend_Amount_USD") : 0;
  const managed = rows ? total(rows.filter((row) => row.Managed_Spend_Flag === "Yes"), "Spend_Amount_USD") : 0;
  const classified = rows ? total(rows.filter((row) => row.Classification_Status === "Classified"), "Spend_Amount_USD") : 0;
  const maverick = rows ? total(rows.filter((row) => row.Maverick_Spend_Flag === "Yes"), "Spend_Amount_USD") : 0;
  const suppliers = rows ? new Set(rows.map((row) => row.Supplier_ID)).size : 0;
  const topSuppliers = rows ? Array.from(rows.reduce((groups, row) => groups.set(row.Parent_Supplier, (groups.get(row.Parent_Supplier) || 0) + row.Spend_Amount_USD), new Map<string, number>()).values()).sort((first, second) => second - first).slice(0, 10).reduce((sum, value) => sum + value, 0) : 0;
  const pct = (value: number) => `${(spend ? value / spend * 100 : 0).toFixed(1)}%`;
  const values: Record<string, { value: string; note: string }> = {
    totalSpend: { value: usd(spend), note: `${rows?.length.toLocaleString()} transactions across the selected period.` },
    spendUnderManagement: { value: usd(managed), note: `${pct(managed)} of selected spend is managed.` },
    classifiedSpend: { value: pct(classified), note: "Share of spend classified in the source data." },
    savingsIdentified: { value: usd(rows ? total(rows, "Savings_Identified_USD") : 0), note: "Identified savings recorded in the source data." },
    maverickSpend: { value: usd(maverick), note: `${pct(maverick)} of selected spend is flagged maverick.` },
    supplierCount: { value: suppliers.toLocaleString(), note: "Distinct suppliers in the selected transactions." },
    strategicSupplierDependency: { value: pct(topSuppliers), note: "Share of spend with the top ten parent suppliers." },
    aiConfidenceScore: { value: `${(rows?.length ? rows.reduce((sum, row) => sum + row.AI_Confidence_Score, 0) / rows.length * 100 : 0).toFixed(1)}%`, note: "Average transaction classification confidence." },
  };
  return (
    <div className="kpi-grid" role="list" aria-label="Key performance indicators">
      {kpiData.map((k) => {
        const Icon = iconMap[k.icon] ?? DollarSign;
        const CustomSvg = customSvgMap[k.id];
        return (
          <div key={k.id} className="kpi-card" role="listitem">
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 4, gap: 8 }}>
              <div className="kpi-card__label">{k.label}</div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
              <div className="kpi-card__value">{rows ? values[k.id].value : k.value}</div>
              {CustomSvg && (
                <span style={{ width: 80, height: 32, display: 'inline-flex', alignItems: 'center', justifyContent: 'flex-end' }}>{CustomSvg}</span>
              )}
            </div>
            <div className={`kpi-card__trend ${rows ? "" : k.up ? "trend-up" : "trend-down"}`}>
              {!rows && (k.up ? <TrendingUp size={14} aria-hidden="true" /> : <TrendingDown size={14} aria-hidden="true" />)}
              {rows ? "Selected transactions" : k.trend}
            </div>
            <div className="kpi-card__note">{rows ? values[k.id].note : k.note}</div>
          </div>
        );
      })}
    </div>
  );
}
